/* global chrome */
import React, { useState } from 'react';
import { AppBar, Avatar, Toolbar, IconButton, Tooltip, Typography, InputBase, Button, Chip, MenuItem, Menu, CircularProgress, Icon, Grid, Popover, List, Paper, ListItem } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import LoginIcon from '@mui/icons-material/Login';
//import HomeIcon from '@mui/icons-material/Home';
//import ForumIcon from '@mui/icons-material/Forum';

import MailIcon from '@mui/icons-material/Mail';
import LanguageIcon from '@mui/icons-material/Language';
import MoreIcon from '@mui/icons-material/MoreVert';
import SettingsIcon from '@mui/icons-material/Settings';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import Extension from '../extension';

import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { isPaidPlan, planDisplayName } from '../../utils/plans';


const SearchAppBar = (props) => {

	const dispatch = useDispatch();
  const navigate = useNavigate();
	const user = useSelector(state => state.user);
	const { root, extensionInstalled, extensionId } = useSelector(state => state.api);

  const [anchorEl, setAnchorEl] = React.useState(null);
	const [searchAnchorEl, setSearchAnchorEl] = React.useState(null);
	const [notificationAnchorEl, setNotificationAnchorEl] = React.useState(null);
  const [notificationLoading, setNotificationLoading] = React.useState(false);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [autoCompleteList, setAutoCompleteList] = React.useState([]);
  const [logOutLoading, setLogOutLoading] = React.useState(false);
  const [ notifications, setNotifications ] = React.useState([]);
  const [isHovered, setIsHovered] = useState(false);
	
  const isMenuOpen = Boolean(anchorEl);
  const isNotificationOpen = Boolean(notificationAnchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);


  function handleOpenUrl(event) {
    window.open('https://chrome.google.com/webstore/detail/trends/malnhaodjdegcljjebmpopbjmckblndn','hi').focus()
  }

  function handleSignOut(event) {
    navigate('/en');
		setLogOutLoading(true)
		fetch(root + `/auth/signout`, { credentials: 'include' })
			.then(res => {
				return res.json();
			})
			.then(json => {
				setLogOutLoading(false)
				console.log('json is', json)
				dispatch({type: 'DESTROY_USER_$'});
			})
			.catch(err => console.log(err))
  }

  function handleProfileMenuOpen(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleNotificationOpen(event) {
    setNotificationLoading(true);
    setNotificationAnchorEl(event.currentTarget);
		fetch(root + `/auth/notification/open`, { credentials: 'include' })
			.then(async res => {
        if (res.ok) return res.json();
        // Fallback for older backend route versions.
        const fallback = await fetch(root + `/auth/notification`, { method: 'post', credentials: 'include' });
				return fallback.json();
			})
			.then(json => {
        console.log('json is', json)
        dispatch({type: 'OPEN_NOTIFICATION'})
        setNotificationLoading(false)
        setNotifications(json.notifications);
			})
			.catch(err => console.log(err))
  }

  function handleMobileMenuClose() {
    setMobileMoreAnchorEl(null);
  }

  function handleMenuClose() {
    setAnchorEl(null);
    setNotificationAnchorEl(null);
    handleMobileMenuClose();
  }

  function handleMobileMenuOpen(event) {
    setMobileMoreAnchorEl(event.currentTarget);
  }

  const handleNotificationContentClick = notification =>{
    setAnchorEl(null)
    setMobileMoreAnchorEl(null)
    setNotificationAnchorEl(null)
    const targetHref = notification?.content?.[0]?.urls?.[0]?.href;
    if(extensionInstalled && targetHref){
      chrome.runtime.sendMessage(extensionId, {
        type: 'OPEN_AUTO_CONTENT',
        contentId: notification.contentId || notification.content?.[0]?._id,
        commentId: notification.commentId,
        pageHref: targetHref,
        content: notification.content?.[0],
      }, function() {});
    } else {
      dispatch({type: 'OPEN_EXTENSION_REQUEST_$'})
    }
  }

  const validURL = string => {
    const  url = 'https://' + string;
    console.log('url is', url);
    try { return Boolean(new URL(url)); }
    catch(e){ console.log('not valid');return false; }
  }

  const menuId = 'primary-search-account-menu';

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
			<MenuItem onClick={()=>navigate('/privacy')}>
        privacy
      </MenuItem>
			<MenuItem onClick={handleSignOut}>
        sign out
      </MenuItem>
    </Menu>
  );

  const handleNotificationClick = notification => {
    if (notification?.type === 'FRIEND_REQUESTED') {
      const actorUsername = notification?.actor?.[0]?.username;
      if (actorUsername) window.open(`${window.location.origin}/${actorUsername}`, '_blank')?.focus();
      return;
    }

    const targetHref = notification?.content?.[0]?.urls?.[0]?.href;
    if (!targetHref) return;

    if (extensionInstalled) {
      chrome.runtime.sendMessage(extensionId, {
        type: 'OPEN_AUTO_CONTENT',
        contentId: notification.contentId || notification.content?.[0]?._id,
        commentId: notification.commentId,
        pageHref: targetHref,
        content: notification.content?.[0],
      }, function() {});
      return;
    }
    window.open(targetHref, '_blank')?.focus();
  }

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
          size="large">
          <MenuIcon />
        </IconButton>
      </MenuItem>
    </Menu>
  );

  const appBarOpacity = !user? 0 : isHovered? 1 : 0.6;

  return (
    <>
      <AppBar 
        position='fixed'
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.92)',
          //visibility: isHovered ? 'visible' : 'hidden',
          opacity: appBarOpacity,
          transition: 'opacity 0.3s ease',
          boxShadow: '0 8px 28px rgba(15, 23, 42, 0.08)',
          borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
          backdropFilter: 'blur(6px)'
        }}
        onMouseOver={() => setIsHovered(true)}
        onMouseOut={() => setIsHovered(false)}
        >
        <Toolbar>
          {/* <IconButton size='large' onClick={()=>{
              navigate('/extension/welcome')
            }} 
          >
            <QuestionMarkIcon />
          </IconButton> */}

          <Tooltip title="How to use" arrow>
            <IconButton
              size='large'
              aria-label="How to use"
              sx={{ color: '#0f172a' }}
              onClick={()=>{
                navigate('/en')
              }}
            >
              <QuestionMarkIcon />
            </IconButton>
          </Tooltip>
            {
              user&&user._id
              ?
                <div>
                  <IconButton
                    edge="end"
                    aria-label="account of current user"
                    aria-haspopup="true"
                    onClick={e=>{
                      /*
                        e.preventDefault();
                          chrome.runtime.sendMessage(extensionId, {type: 'OPEN_ACTIVITY_BY_WEBPAGE', personName: user.username, user }, function(response) {
                        })
                      */
                      navigate(`/${user?.username || ''}`)
                    }}
                    size="large"
                    socialbrowse-activity-button
                    sx={{ color: '#0f172a' }}
                  >
                    <Avatar className='special-button' src={user.profileImageUrl}/>
                  </IconButton>
                </div>
              :
                <div>
                  <IconButton size='large' sx={{ color: '#0f172a' }} onClick={()=>{
                    navigate('/extension/signin')
                    }} 
                  >
                      <LoginIcon />
                  </IconButton>
                  {//<Skeleton style={{cursor: 'pointer'}} onClick={() => props.navigate('/extension/signin')} variant="circular"><Avatar /></Skeleton>
                  }
                </div>
            }
          {
            /*

          <div className={classes.sectionDesktop}>
            <IconButtoi
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              size="large"
            >
              <MenuIcon />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpe}
              size="large">
              <MoreIcon />
            </IconButton>
          </div>
            */
          }
          <Chip
            size="small"
            label={planDisplayName(user?.subscriptionStatus)}
            onClick={() => navigate('/pricing')}
            sx={{
              ml: 0.5,
              height: 24,
              fontWeight: 600,
              fontSize: '0.7rem',
              letterSpacing: '0.04em',
              bgcolor: isPaidPlan(user?.subscriptionStatus) ? '#fef3c7' : 'grey.100',
              color: isPaidPlan(user?.subscriptionStatus) ? '#92400e' : 'text.secondary',
              border: isPaidPlan(user?.subscriptionStatus) ? '1px solid #fde68a' : '1px solid rgba(15, 23, 42, 0.08)',
              cursor: 'pointer',
              '&:hover': {
                bgcolor: isPaidPlan(user?.subscriptionStatus) ? '#fde68a' : 'grey.200',
              },
            }}
          />
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </>
  );
}

export default SearchAppBar;
